import { ref } from 'vue'
import { isSSR } from '@js/App/Utils/Environment'

export const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

export const isWindows = () => window?.navigator?.userAgent?.includes('Win')

/**
 * Detect the mobile operating system from the user agent.
 * iPadOS 13+ reports a desktop Safari UA, so fall back to the
 * MacIntel-with-touch signal to still classify iPads as iOS.
 * @returns {'Android'|'iOS'|'unknown'}
 */
export const getMobileOperatingSystem = () => {
  if (isSSR()) { return 'unknown' }

  const userAgent = navigator.userAgent || navigator.vendor || window.opera || ''

  if (/android/i.test(userAgent)) {
    return 'Android'
  }

  const isIOSUserAgent = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  if (isIOSUserAgent || isIPadOS) {
    return 'iOS'
  }

  return 'unknown'
}

export const useIsMobile = () => {
  const isMobile = ref(checkIfIsMobile())

  if (!isSSR()) {
    window.addEventListener('resize', (event) => {
      isMobile.value = checkIfIsMobile()
    })
  }

  return { isMobile }
}

const checkIfIsMobile = () => {
  if (isSSR()) { return false }
  return window.innerWidth < 769
}
